import { isAfter, isValid } from 'date-fns';
import { ExpiresOn } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { getBudgetLengthDetails } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/getBudgetLengthDetails';
import { MealCreditInfoTextProps } from './constructMealCreditInfoText.utils';

export function isDurationRuleValid(
  props: Pick<
    MealCreditInfoTextProps,
    | 'startDate'
    | 'endTimeFullDate'
    | 'errors'
    | 'budgetResetPeriod'
    | 'budgetResetType'
    | 'budgetLength'
    | 'expirationDate'
    | 'expiresOn'
    | 'isRepeating'
    | 'refreshPeriodDaysCount'
    | 'monthAvailableTo'
  >
): boolean {
  const {
    startDate,
    endTimeFullDate,
    errors,
    budgetResetPeriod,
    budgetResetType,
    budgetLength,
    expirationDate,
    expiresOn,
    isRepeating,
    refreshPeriodDaysCount,
    monthAvailableTo,
  } = props;

  const { isCustomLengthBudget, isMonthAvailable } = getBudgetLengthDetails(
    budgetLength,
    budgetResetType
  );
  // If the budget length is custom weeks but no budget reset period is provided, it is invalid
  if (isCustomLengthBudget && !budgetResetPeriod) {
    return false;
  }

  // If the expiresOn is ON_THIS_DAY but no expiration date is provided, it is invalid
  if (
    isRepeating &&
    expiresOn === ExpiresOn.ON_THIS_DAY &&
    !isValid(expirationDate)
  ) {
    return false;
  }

  // Ensure that the refresh period is a positive number and not NaN; otherwise, the rule is invalid
  const isRefreshPeriodDaysCountValid = refreshPeriodDaysCount > 0;

  if (!isRefreshPeriodDaysCountValid) {
    return false;
  }

  // Return false if there are any specific errors or if the dates are invalid
  const hasErrors =
    errors.startTime ||
    errors.endTime ||
    errors.days ||
    errors.budgetResetPeriod;

  const isMonthAvailableToValid =
    !isMonthAvailable ||
    (isValid(monthAvailableTo) && isAfter(monthAvailableTo, startDate));

  const invalidDates =
    !isValid(startDate) ||
    !isValid(endTimeFullDate) ||
    !isMonthAvailableToValid;

  return !(hasErrors || invalidDates);
}
